'use strict';

require('./bootstrap');
require('./directives/FieldError');